import { IconName } from '../../icon';

export const FileUploaderIconNameByExtension: Record<string, IconName> = {
  csv: IconName.DocumentCSV,
  doc: IconName.DocumentDOC,
  docx: IconName.DocumentDOC,
  pdf: IconName.DocumentPDF,
  xls: IconName.DocumentXls,
  xlsx: IconName.DocumentXls,
  png: IconName.Image,
  jpeg: IconName.Image,
  jpg: IconName.Image,
};
